import { Badge } from '@/components/ui/badge';

const labels: Record<string, string> = {
  uploading: 'Uploading',
  attached: 'Ready',
  cancelled: 'Cancelled',
};

const statusStyles: Record<string, string> = {
  attached: 'bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200',
  uploading:
    'bg-amber-100 text-amber-700 dark:bg-amber-800 dark:text-amber-200',
  cancelled: 'bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200',
};

type StatusBadgeProps = {
  status: string;
  className?: string;
};

export default function UploadStatusBadge({
  status,
  className,
}: StatusBadgeProps) {
  const styles = statusStyles[status] || '';
  return (
    <Badge variant={'outline'} className={`${styles} ${className}`}>
      {labels[status] || status}
    </Badge>
  );
}
